import { Box, Button, SvgIcon, Typography } from "@mui/material";
import { SxProps, useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ConfigContext } from "../../../context/ConfigContext";
import { DealerAccountContext } from "../../../context/DealerAccountContext";
import { getHomeUrl } from "../../../utils/legacyHome";

export type ErrorPageProps = {
  title: string;
  subtitle: JSX.Element | string;
  icon: { Component: typeof SvgIcon; styles: SxProps };
  returnHomeButtonText?: string;
  reloadFn?: () => void;
};

const ErrorPage = ({
  title,
  subtitle,
  icon,
  returnHomeButtonText,
  reloadFn,
}: ErrorPageProps) => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  const { JDPO_JAVA_URL, JDPOINT_URL, ENABLE_REMOVE_DASHBOARD_TAB } =
    useContext(ConfigContext);
  const { dealerAccount } = useContext(DealerAccountContext);
  const homeUrl = getHomeUrl(
    JDPO_JAVA_URL,
    JDPOINT_URL,
    dealerAccount?.id as string,
    ENABLE_REMOVE_DASHBOARD_TAB
  );
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
      data-testid="error-page"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <icon.Component data-testid="error-icon" sx={icon.styles} />

        <Typography
          data-testid="error-title"
          sx={{
            textAlign: "center",
            paddingTop: theme.tokens.FuelSpacing4,
            paddingBottom: theme.tokens.FuelSpacing2,
            fontWeight: theme.tokens.FuelFontWeightSemibold,
            fontSize: theme.tokens.FuelFontSizeMd,
            color: theme.tokens.FuelColorTextPrimary,
          }}
        >
          {title}
        </Typography>
        <Typography
          data-testid="error-subtitle"
          sx={{
            textAlign: "center",
            fontWeight: theme.tokens.FuelFontWeightRegular,
            fontSize: theme.tokens.FuelFontSizeMd,
            color: theme.tokens.FuelColorTextTertiary,
            paddingBottom: theme.tokens.FuelSpacing4,
          }}
        >
          {subtitle}
        </Typography>
        {returnHomeButtonText && (
          <Link
            data-testid="error-button"
            style={{
              textDecoration: "none",
              color: theme.tokens.FuelColorTextPrimary,
            }}
            to={homeUrl}
          >
            <Button data-testid="return-home-button" variant="primary">
              {returnHomeButtonText}
            </Button>
          </Link>
        )}

        {reloadFn && (
          <Button
            variant="primary"
            data-testid="refresh-button"
            onClick={reloadFn}
          >
            {t("error.refresh")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ErrorPage;
